import getObjectPath from "../get-object-path";
import { context } from "../../components/wr-context";
var getLocalizedProperty = function(localizedObj, propertyPath) {
    var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", locale = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : context.constants.locale;
    if (locale === "en" || !localizedObj.languages) {
        return getObjectPath(localizedObj, propertyPath, defaultValue);
    } else {
        return getObjectPath(localizedObj, "languages.".concat(locale, ".").concat(propertyPath), defaultValue);
    }
};
export default getLocalizedProperty;
